const messages = {
    accountBox: {
        title: "Dashboard",
        description: "Få hurtigt overblik over dine kampagner og point.",
        button: "ÅBN DASHBOARD",
    },
};

export default {
    messages,
};
